import { NON_DIGITS_REGEX } from '../regex';
import { INVALID, VALID } from './constants';
var ACCOUNT_NUMBER_LENGTH = 11;
var format = function format(accountNumber, bankName) {
  return "".concat(accountNumber, " ").concat(bankName);
};
var isValidAccountNumber = function isValidAccountNumber(account) {
  var controlNumber = 2;
  var sumForMod = 0;
  var i;

  // eslint-disable-next-line no-plusplus
  for (i = account.length - 2; i >= 0; --i) {
    sumForMod += account.charAt(i) * controlNumber;
    // eslint-disable-next-line no-plusplus
    if (++controlNumber > 7) {
      controlNumber = 2;
    }
  }

  // eslint-disable-next-line no-mixed-operators
  var result = (11 - sumForMod % 11) % 11;
  return parseInt(account.charAt(account.length - 1), 10) === result;
};
var parse = function parse(bankAccount) {
  var result = {
    valid: INVALID,
    bank: null,
    bankAccount: '',
    formatted: '',
    error: {
      type: 'genericError',
      message: "Invalid bank account: ".concat(bankAccount)
    }
  };
  var sanitized = bankAccount.replace(NON_DIGITS_REGEX, '');
  if (sanitized.length !== ACCOUNT_NUMBER_LENGTH) {
    result.error.type = 'length';
    result.error.message = "Invalid bank account length: ".concat(bankAccount);
    return result;
  }
  var bank = bankAccount.split(' ').length === 1 ? '-' : bankAccount.split(' ').pop();
  if (!isValidAccountNumber(sanitized)) {
    return result;
  }
  result.bankAccount = sanitized;
  result.bank = bank;
  result.valid = VALID;
  result.formatted = format(result.bankAccount, result.bank);
  result.error.type = null;
  result.error.message = null;
  return result;
};
export default parse;